
const CrudCodeValues = require("./CrudCodeValues");
module.exports = {
    TC: "TC",
    JC: "JC",
    UJ: "UJ",
    SY: "SY",
    EL: "EL",
    EEL: "EEL",
    AEL: "AEL",
    IEL: "IEL",
    HPE: "HPE",
    AS: "AS",
    FU: "FU",
    DF: "DF",
    WS: "WS",
    CS: "CS"
};
